// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  width: 100%;
  height: 100%;
  padding: 0 1em;
  overflow-y: auto;
}

.bar-page {
  display: flex;
  height: 100%;
  width: 100vw;
}

.bar-page h1,
h2,
h3 {
  margin: 0;
  padding-top: 2em;
}

.side-nav {
  z-index: 1000;
  left: 0;
  padding: 0;
  margin-left: .5em;
  width: 20em;
}

.side-nav>ul {
  display: flex;
  background-color: white;
  border-radius: 10px;
  height: 77%;
  padding: 1em 0 !important;
  margin: .2em 0;
}

.profile-link {
  padding: 3em 5em 2em;
  background-color: white;
  border-radius: 10px;
}

.profile-link a {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .9em;
  cursor: pointer;
}


.profile-link a div span:not(.display-type):hover {
  text-decoration: underline;
  text-underline-offset: 0.2rem;
}

.display-type {
  font-size: .75em;
  color: rgb(111, 111, 111);

}

.side-nav ul {
  text-align: center;
  list-style-type: none;
  flex-direction: column;
  padding: 0 .1em;
}

.side-nav ul li {
  display: block;
  /* min-width: 14.5em; */
  min-width: 12em;

}

.side-nav ul li a {
  all: unset;
  text-decoration: none;
  display: block;
  padding: .5em 1em;
}

.side-nav ul li a:hover {
  color: white;
  background-color: var(--purple-drk);
  cursor: pointer;
}

.li-last {
  margin: auto 0 1em;
}


.cocktail-detail-card {
  background-color: #fff;
  white-space: pre;
  min-height: 98%;
  border-radius: 10px;
  ;
}`, "",{"version":3,"sources":["webpack://./src/features/bar/bar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;;AAGA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;;AAE3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;;AAEjB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;AAErB","sourcesContent":[".page-content {\n  width: 100%;\n  height: 100%;\n  padding: 0 1em;\n  overflow-y: auto;\n}\n\n.bar-page {\n  display: flex;\n  height: 100%;\n  width: 100vw;\n}\n\n.bar-page h1,\nh2,\nh3 {\n  margin: 0;\n  padding-top: 2em;\n}\n\n.side-nav {\n  z-index: 1000;\n  left: 0;\n  padding: 0;\n  margin-left: .5em;\n  width: 20em;\n}\n\n.side-nav>ul {\n  display: flex;\n  background-color: white;\n  border-radius: 10px;\n  height: 77%;\n  padding: 1em 0 !important;\n  margin: .2em 0;\n}\n\n.profile-link {\n  padding: 3em 5em 2em;\n  background-color: white;\n  border-radius: 10px;\n}\n\n.profile-link a {\n  all: unset;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: .9em;\n  cursor: pointer;\n}\n\n\n.profile-link a div span:not(.display-type):hover {\n  text-decoration: underline;\n  text-underline-offset: 0.2rem;\n}\n\n.display-type {\n  font-size: .75em;\n  color: rgb(111, 111, 111);\n\n}\n\n.side-nav ul {\n  text-align: center;\n  list-style-type: none;\n  flex-direction: column;\n  padding: 0 .1em;\n}\n\n.side-nav ul li {\n  display: block;\n  /* min-width: 14.5em; */\n  min-width: 12em;\n\n}\n\n.side-nav ul li a {\n  all: unset;\n  text-decoration: none;\n  display: block;\n  padding: .5em 1em;\n}\n\n.side-nav ul li a:hover {\n  color: white;\n  background-color: var(--purple-drk);\n  cursor: pointer;\n}\n\n.li-last {\n  margin: auto 0 1em;\n}\n\n\n.cocktail-detail-card {\n  background-color: #fff;\n  white-space: pre;\n  min-height: 98%;\n  border-radius: 10px;\n  ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
